import {Routes} from '@angular/router';
import {TableauDeBordComponent} from './tableau-de-bord/tableau-de-bord.component';
import {ListeDesParticipantsComponent} from './liste-des-participants/liste-des-participants.component';
import {ConfigurerGeneralComponent} from './configurer-general/configurer-general.component';
import {ConfigurerMaListeComponent} from './configurer-ma-liste/configurer-ma-liste.component';
import {MesInformationsComponent} from './mes-informations/mes-informations.component';
import {ParametresComponent} from './parametres/parametres.component';
import {AideComponent} from './aide/aide.component';
import {GererLesAccesComponent} from './gerer-les-acces/gerer-les-acces.component';
import {SupportComponent} from './support/support.component';
import {RedirectComponent} from './redirect/redirect.component';
import {SignAlertComponent} from './sign-alert/sign-alert.component';
import {RedirectToBoOnlineComponent} from './redirect-to-bo-online/redirect-to-bo-online.component';
import {AuthGuard} from "@auth0/auth0-angular";
import {MemberPageGuard} from "./services/member-page.guard";

const routes: Routes = [
  // {path: 'nouveau-compte', component: NouveauCompteComponent},
  {path: 'redirect-to-bo-online', component: RedirectToBoOnlineComponent},
  {path: 'tableau-de-bord', canActivate: [AuthGuard, MemberPageGuard], component: TableauDeBordComponent},
  {path: 'liste-des-participants', canActivate: [AuthGuard, MemberPageGuard], component: ListeDesParticipantsComponent},
  {path: 'configurer-general', canActivate: [AuthGuard, MemberPageGuard], component: ConfigurerGeneralComponent},
  {path: 'configurer-ma-liste', canActivate: [AuthGuard, MemberPageGuard], component: ConfigurerMaListeComponent},
  {path: 'gerer-les-acces', canActivate: [AuthGuard, MemberPageGuard], component: GererLesAccesComponent},
  {path: 'mes-informations', canActivate: [AuthGuard], component: MesInformationsComponent},
  {path: 'parametres', canActivate: [AuthGuard, MemberPageGuard], component: ParametresComponent},
  {path: 'aide', canActivate: [AuthGuard], component: AideComponent},
  {path: 'support', canActivate: [AuthGuard], component: SupportComponent},
  {path: 'redirect', canActivate: [AuthGuard], component: RedirectComponent},
  {path: 'deconnecte', component: SignAlertComponent},
  {path: '', redirectTo: 'tableau-de-bord', pathMatch: 'full'},
  {path: '**', redirectTo: 'tableau-de-bord'}

];
export default routes
